import { DefaultApplication } from '@/components/modules/Application/Default/DefaultApplication';
import { useApplicationNavigation } from '@/components/modules/Application/hooks/useApplicationNavigation';
import { ApplicationIberiaCardsStands } from '@/components/modules/Application/IberiaCards/ApplicationIberiaCardsStands';
import { CustomAlert } from '@/components/shared/components/CustomAlert';
import { PageLeaveGuard } from '@/components/shared/components/PageLeaveGuard';
import { useAutoHideLeftMenu } from '@/components/shared/hooks/useAutoHideLeftMenu';
import { UserEntity } from '@/entities/UserEntity';
import { isIbcStandsAgentUser } from '@/hooks/layoutConstructor/iberiaUserHelpers';
import { useUser } from '@/hooks/useUser';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const Application = () => {
  const { userEntity } = useUser();
  const { isDirty, isCompleted } = useApplicationNavigation();

  // hide left menu on mount / screen reduction
  useAutoHideLeftMenu();

  return (
    <>
      <ApplicationByUser userEntity={userEntity} />
      <PageLeaveGuard
        titleTextId={'LEAVE_APPLICATION'}
        descriptionTextId={'LEAVE_NOTICE'}
        mainButtonTextId={'LEAVE'}
        condition={isDirty && !isCompleted}
      />
    </>
  );
};

export const ApplicationModule = withPermissionsModule(Application);

interface ApplicationByUserProps {
  userEntity: UserEntity | undefined;
}

const ApplicationByUser = ({ userEntity }: ApplicationByUserProps) => {
  if (userEntity && isIbcStandsAgentUser(userEntity)) {
    return <ApplicationIberiaCardsStands />;
  }

  if (userEntity?.isCreditCardUser()) {
    return (
      <CustomAlert
        severity="warning"
        title={'IBERIA_CARDS_APPLICATION_NOT_AVAILABLE'}
        description={'IBERIA_CARDS_APPLICATION_NOT_AVAILABLE_DESCRIPTION'}
      />
    );
  }

  return <DefaultApplication />;
};
